/** Torchlit + Heraldry colours for canvas and SVG art; CSS reads the same values from theme.css. */
export const PALETTE = {
  gold: '#f2c14e',
  goldText: '#ffd27a',
  goldRim: '#e8c46e',
  iron: '#9c8460',
  mortar: '#141217',
  trim: '#f2d38a',
} as const;
